import Vue from 'vue';
import { isEqual } from 'lodash-es';

import { httpClient } from '@api';
import { Customer } from './customer.dto';
import { CustomerInsight } from './customer-insight.dto';

export default {
  update: async (payload) => httpClient.post('customers/update', payload),
  updateMany: async (payload) => httpClient.post('customers/update-many', payload),
  enableWorkflow: async (payload) => httpClient.post('customers/workflow/enabled', payload),
  delete: async (payload) => httpClient.post('customers/delete', payload),
  fetchCustomersChart: async (payload) => httpClient.post('customers/chart', payload),
  fetchCountOverdue: async (payload) => httpClient.post('customers/count-overdue', payload),
  fetchCustomersRisk: async (payload) => httpClient.post('customers/count-risk', payload),
  fetchCustomersCreditLimit: async (payload) => httpClient.post('customers/credit-limit', payload),
  fetchMetrics: async (payload) => httpClient.post('customers/metrics', payload),
  fetchCustomersIdsWithOpenInvoices: async (payload) => httpClient.post('customers/ids-with-open-invoices', payload),
  fetchCustomersIds: async (payload) => httpClient.post('customers/ids', payload),
  getNonExistingIds: async (payload) => httpClient.post('customers/non-existing-ids', payload),
  customersAddUpdateField: async (payload) => httpClient.post('customers/add-update-field', payload),
  find: async (payload) => httpClient.post('customers/find', payload),
  async list(payload) {
    try {
      const data = await httpClient.post('customers/list', payload);

      if (isEqual(payload.contentType, 'link-xlsx')) {
        return data;
      }

      const { list, stats } = data;
      const normalizedList = list.map((item) => new Customer(item));
      return { list: normalizedList, stats };
    } catch (err) {
      console.warn(err);
    }
  },
  async fetchCustomerInsights(payload) {
    return httpClient.post('customer/insight', {
      companyId: Vue.auth.user().selectedCompany.id,
      ...payload,
    });
  },
  async rateInsight(payload) {
    const insight = new CustomerInsight({
      companyId: Vue.auth.user().selectedCompany.id,
      ...payload,
    });

    return httpClient.post('customer/insight/rate', insight);
  },
};
